import React, { useContext, CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';

const styles: Record<string, CSSProperties> = {
  page: {
    minHeight: '100vh',
    background: 'var(--bg-primary)',
    color: 'var(--text-primary-color)',
    padding: '60px',
    marginTop: '50px',
    fontFamily: 'Inter, system-ui, sans-serif'
  },
  header: {
    fontSize: '30px',
    fontWeight: '600',
    marginBottom: '10px'
  },
  subheader: {
    fontSize: '16px',
    opacity: 0.7,
    marginBottom: '20px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '30px'
  },
  card: {
    background: 'var(--bg-classify)',
    borderRadius: '16px',
    padding: '30px',
    cursor: 'pointer',
    // boxShadow: '0 0 0 1px rgba(255,255,255,0.05), 0 30px 60px rgba(0,0,0,0.6)',
    transition: 'all 0.25s ease',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px'
  },
  cardDesc: {
    fontSize: '14px',
    lineHeight: 1.5,
    opacity: 0.7
  }
};

const SuperAdminDashboard: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);
  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }

  const modules = [
    {
      title: 'Register User',
      description: 'Create a new BITE user',
      route: '/_ru/5tg8ov34h'
    },
    {
      title: 'Create a Team',
      description: 'Create a new team with an assigned admin in Keycloak',
      route: '/_mt/7b4e91m7x'
    },
    {
      title: 'Manage Teams',
      description: 'View teams and create subscriptions',
      route: '/_ta/a83f2d94y'
    }
  ];

  return (
    <div style={styles.page}>
      <h1 style={styles.header}>Super Admin Dashboard</h1>
      <p style={styles.subheader}>Choose a module to continue</p>
      <div style={styles.grid}>
        {modules.map((mod, index) => (
          <Link to={mod.route} key={index} style={{ color: 'var(--text-primary-color)' }}>
            <div
              style={styles.card}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <h2 style={styles.cardTitle}>{mod.title}</h2>
              <p style={styles.cardDesc}>{mod.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
